export default {
  any_device: 'any',
  blocked: 'blocked',
  online: 'online',
  offline: 'offline'
};
